import { EntityFields } from '@/entities/utils/types'
import { Transaction, TransactionEntry } from './types'

export { TRANSACTION_ID_PREFIX } from '@/const/common'

export const TRANSACTION_FIELD: EntityFields<Transaction> = {
  ID: 'id',
  DATE: 'date',
  TYPE: 'type',
  DESCRIPTION: 'description',
  ENTRIES: 'entries',
  REPOSITORY_ID: 'repository_id',
  SOURCE: 'source',
  DELETED_AT: 'deleted_at',
  CREATED_AT: 'created_at',
  CREATED_BY: 'created_by',
  CREATED_BY_EMAIL: 'created_by_email',
  UPDATED_AT: 'updated_at',
  UPDATED_BY: 'updated_by',
  UPDATED_BY_EMAIL: 'updated_by_email',
  LINKED_ID: 'linked_id',
}

export const TRANSACTION_ENTRY_FIELD: EntityFields<Omit<TransactionEntry, 'Account type' | 'Asset type'>> = {
  ACCOUNT_ID: 'account_id',
  AMOUNT: 'amount',
  ASSET_ID: 'asset_id',
  POS_ID: 'pos_id',
}

export const TRANSACTION_DEFAULT_DATA = {
  id: '',
  date: '',
  type: '',
  description: '',
  entries: [],
  repository_id: '',
}

export const TRANSACTION_FIELD_LABEL = {
  [TRANSACTION_FIELD.DATE]: 'Date',
  [TRANSACTION_FIELD.TYPE]: 'Type',
  [TRANSACTION_FIELD.DESCRIPTION]: 'Description',
  [TRANSACTION_FIELD.CREATED_AT]: 'Created at',
  [TRANSACTION_FIELD.UPDATED_AT]: 'Updated at',
  [TRANSACTION_FIELD.CREATED_BY_EMAIL]: 'Created by',
  [TRANSACTION_FIELD.UPDATED_BY_EMAIL]: 'Updated by',
}

export const TRANSACTION_ENTRY_FIELD_LABEL = {
  [TRANSACTION_ENTRY_FIELD.ACCOUNT_ID]: 'Account',
  [TRANSACTION_ENTRY_FIELD.AMOUNT]: 'Amount',
  [TRANSACTION_ENTRY_FIELD.ASSET_ID]: 'Asset',
}

/**
 * Transaction types by name, as the repository's transaction settings name them.
 *
 * A mirror of backend data, not a set the frontend owns: the settings list is
 * what actually enumerates them (`useTransactionsSettingsStore`) and a
 * repository's plan decides which of them it has. These four are the ones the
 * assistants and the asset wizards name explicitly, so they are written down
 * once rather than spelled out at each call site.
 */
export const TRANSACTION_TYPE = {
  ADD_POSITION: 'add position',
  ADD_LIABILITY: 'add liability',
  SUBSCRIBE_AND_COMMIT: 'subscribe and commit',
  SUBSCRIBE_AND_FUND: 'subscribe and fund',
} as const
